export const encodeStr = (str) => {
  return Uint8Array.from(str, (c) => c.charCodeAt(0));
};

export const encodeStrToByteArray = (e) => {
  const t = e.replace(/-/g, "+").replace(/_/g, "/"),
    r = (4 - (t.length % 4)) % 4,
    n = t.padEnd(t.length + r, "="),
    o = atob(n);
  return Uint8Array.from(o, (c) => c.charCodeAt(0)).buffer;
};

export const decodeToStr = (buffer) => {
  // return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)));
  return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");
};

export const parseKeyToatobtr = (buffer, key) => {
  const tempStr = String.fromCharCode.apply(null, new Uint8Array(buffer));
  if (tempStr) {
    const parsedJson = JSON.parse(tempStr);
    const valueToDecode = parsedJson[key];
    if (valueToDecode) {
      parsedJson[key] = atob(valueToDecode);
      return btoa(JSON.stringify(parsedJson))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");
    }
  }
};

export const base64ToArrayBuffer = (binaryString) => {
  var bytes = new Uint8Array(binaryString.length);
  for (var i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};
